// "9" -> "Grade 9", "Grade 9" -> "Grade 9" (never "Grade Grade 9"). Non-numeric names are left alone.
export const gradeLabel = (name: unknown): string => {
  const n = String(name ?? '').trim();
  const bare = n.replace(/^grade\s+/i, '');
  return /^\d+[A-Za-z]?$/.test(bare) ? `Grade ${bare}` : n;
};

// "Grade 10" -> "G10", "10B" -> "G10B", "11 Natural" -> "G11 Nat" (the stream keeps a short suffix so pills stay unique).
// Other names are left alone.
export const gradeCompact = (name: unknown): string => {
  const n = String(name ?? '').trim();
  const bare = n.replace(/^grade\s+/i, '');
  if (/^\d+[A-Za-z]?$/.test(bare)) return `G${bare}`;
  const m = bare.match(/^(\d+)\s+(\S.*)$/);
  if (m) {
    const stream = m[2].replace(/[^\p{L}]/gu, '').slice(0, 3);
    if (stream) return `G${m[1]} ${stream[0].toUpperCase()}${stream.slice(1).toLowerCase()}`;
  }
  return n;
};
